import React, {RefObject} from 'react';
import {withRouter, RouteComponentProps} from 'react-router';

import styles from './ScrollToTop.scss';

class ScrollToTop extends React.Component<RouteComponentProps> {
  focusRef: RefObject<HTMLDivElement> = React.createRef();

  componentDidUpdate(prevProps: RouteComponentProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);

      if (!this.focusRef.current) return;
      this.focusRef.current.focus();
    }
  }

  render() {
    return (
      <div tabIndex={-1} ref={this.focusRef} className={styles.ScrollToTop}>
        {this.props.children}
      </div>
    );
  }
}

export default withRouter(ScrollToTop);
